import React, { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class MerchantAuthentication  extends Component {

    

    render() {

        // var userToken = localStorage.getItem('token');
        // if(! userToken) {
        //       return <Navigate  to='/login' replace="true" />
        //   }

          var headerExample = JSON.stringify({
            "x-access-key": "YOUR_ACCESS_KEY",
            "x-timestamp": "1750000000",
            "x-nonce": "550e8400-e29b-41d4-a716-446655440000",
            "x-signature": "8a5f2d0b8e9f...",
            }, null, 2);
      
        var signatureExample = `HMAC_SHA256(
            canonical_message,
            SECRET_KEY
        )
        
        Output should be encoded as a hexadecimal string.`;

        const nodeExample = `const crypto = require('crypto');
const { randomUUID } = require('crypto');

const accessKey = 'YOUR_ACCESS_KEY';
const secretKey = 'YOUR_SECRET_KEY';

const method = 'POST';
const path = '/api/v1/remittance/create';

const timestamp = Math.floor(Date.now() / 1000).toString();
const nonce = randomUUID();

const body = {
  amount: 100,
  currency: 'USD'
};

const bodyString = JSON.stringify(body);

const message = [
  method.toUpperCase(),
  path,
  timestamp,
  nonce,
  bodyString
].join('\\n');

const signature = crypto
  .createHmac('sha256', secretKey)
  .update(message)
  .digest('hex');

console.log({
  accessKey,
  timestamp,
  nonce,
  signature
});`;

        const curlExample = `curl --request POST \\
                        --url https://api.example.com/api/v2/merchant/get-payout-list \\
                        --header "Content-Type: application/json" \\
                        --header "x-access-key: YOUR_ACCESS_KEY" \\
                        --header "x-timestamp: 1750000000" \\
                        --header "x-nonce: 550e8400-e29b-41d4-a716-446655440000" \\
                        --header "x-signature: GENERATED_SIGNATURE" \\
                        --data '{
                            "corridor": "bank",
                            "session_id": "SESS_7EMV5GSEZYQLO95F17SK4G6AB45NDFAS"
                        }'`; 

        const copyClipboard = (e,data) => {
            console.log('copyClipboard');
            e.preventDefault();
            navigator.clipboard.writeText(data);
            toast.success('Data copied !', {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            });
        };

        return (
            <div>
                <div class="docs-content">
                    <div class="container">
                    <article class="docs-article">

                        <h1 class="docs-heading">
                            Authentication &amp; HMAC Signature
                        </h1>

                        <section class="docs-intro">

                            <p>
                                All API requests must be authenticated using HMAC SHA256
                                signatures to ensure secure communication between the partner
                                system and the E-Pocket Merchant API.
                            </p>

                            <p>
                                Partners are responsible for generating a valid timestamp,
                                nonce, and HMAC signature for every request using their
                                assigned Access Key and Secret Key.
                            </p>

                            <p>
                                Each request must include the required authentication
                                headers, which are validated by the server before the request
                                is processed.
                            </p>

                        </section>

                    </article>

                    <article class="docs-article">

                        <section class="docs-section">

                        <h2 class="section-heading">
                        Authentication Credentials
                        </h2>

                        <p>
                        The following credentials are provided during merchant onboarding.
                        </p>

                        <table class="table table-bordered table-white">

                        <thead>

                        <tr>
                        <th>Credential</th>
                        <th>Description</th>
                        </tr>

                        </thead>

                        <tbody>

                        <tr>
                        <td>Access Key</td>
                        <td>Unique merchant identifier used in request headers.</td>
                        </tr>

                        <tr>
                        <td>Secret Key</td>
                        <td>Confidential key used to generate the HMAC SHA256 signature.</td>
                        </tr>

                        </tbody>

                        </table>

                        </section>

                        </article>

                        <article class="docs-article">

                        <section class="docs-section">

                        <h2 class="section-heading">
                        Access Key
                        </h2>

                        <p>
                        The Access Key uniquely identifies the merchant and must be included
                        in the <code>x-access-key</code> header for every API request.
                        </p>

                        </section>

                        </article>

                        <article class="docs-article">

                        <section class="docs-section">

                        <h2 class="section-heading">
                        Secret Key
                        </h2>

                        <p>
                        The Secret Key is used to generate the HMAC SHA256 signature.
                        It must be stored securely on the server side and must never be
                        exposed in frontend, mobile, or client-side applications.
                        </p>

                        </section>

                        </article>

                        <article class="docs-article">

                        <section class="docs-section">

                        <h2 class="section-heading">
                        Required Headers
                        </h2>

                        <table class="table table-bordered table-white">

                        <thead>

                        <tr>
                        <th>Header</th>
                        <th>Description</th>
                        </tr>

                        </thead>

                        <tbody>

                        <tr>
                        <td>x-access-key</td>
                        <td>Merchant Access Key</td>
                        </tr>

                        <tr>
                        <td>x-timestamp</td>
                        <td>Current Unix Timestamp (seconds)</td>
                        </tr>

                        <tr>
                        <td>x-nonce</td>
                        <td>Unique UUID v4 (32 characters)</td>
                        </tr>

                        <tr>
                        <td>x-signature</td>
                        <td>HMAC SHA256 Signature</td>
                        </tr>

                        <tr>
                        <td>Content-Type</td>
                        <td>application/json</td>
                        </tr>

                        </tbody>

                        </table>

                        </section>

                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Example Request Headers
                                </h2>

                                <pre>
                                    <code class="copybox-code">
                        {headerExample}
                                    </code>
                                </pre>

                            </section>
                        </article>


                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Signature Generation
                                </h2>

                                <p>
                                    The signature is generated using the merchant 
                                    <code>Secret Key</code> and a canonical request message.
                                </p>

                                <pre>
                                    <code class="copybox-code">
                                        {signatureExample}
                                    </code>
                                </pre>

                                <p>
                                    The generated output must be encoded as a hexadecimal string.
                                </p>

                            </section>
                        </article>


                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Canonical Message Structure
                                </h2>

                                <p>
                                    The HMAC signature must be generated using the following canonical
                                    message format:
                                </p>

                                <pre>
                                    <code class="copybox-code">
                                        {`HTTP_METHOD
REQUEST_PATH
TIMESTAMP
NONCE
REQUEST_BODY`}
                                    </code>
                                </pre>


                                <h4 class="mt-4">
                                    Example Canonical Message
                                </h4>

                                <pre>
                                    <code class="copybox-code">
                        {`POST
/api/v1/remittance/create
1750000000
550e8400-e29b-41d4-a716-446655440000
{"amount":100,"currency":"USD"}`}
                                    </code>
                                </pre>

                            </section>
                        </article>


                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Signature Generation Rules
                                </h2>

                                <ul>
                                    <li>
                                        Use uppercase HTTP method values.
                                    </li>

                                    <li>
                                        Use only the API URL path and exclude the domain name.
                                    </li>

                                    <li>
                                        Timestamp must be generated using Unix timestamp format in seconds.
                                    </li>

                                    <li>
                                        Generate a unique nonce for every API request.
                                    </li>

                                    <li>
                                        Request body must be compact JSON without formatting spaces.
                                    </li>
                                </ul>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Signature Components
                                </h2>

                                <table class="table table-bordered table-white">
                                    <thead>
                                        <tr>
                                            <th>Component</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>HTTP_METHOD</td>
                                            <td>API request method (GET, POST, etc.).</td>
                                        </tr>

                                        <tr>
                                            <td>REQUEST_PATH</td>
                                            <td>API endpoint path.</td>
                                        </tr>

                                        <tr>
                                            <td>TIMESTAMP</td>
                                            <td>Current Unix timestamp.</td>
                                        </tr>

                                        <tr>
                                            <td>NONCE</td>
                                            <td>Unique request identifier.</td>
                                        </tr>

                                        <tr>
                                            <td>REQUEST_BODY</td>
                                            <td>JSON request payload.</td>
                                        </tr>

                                        <tr>
                                            <td>SECRET_KEY</td>
                                            <td>Merchant Secret Key.</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <div class="copybox mb-3">
                                    <div class="copybox-top">
                                        <p class="copybox-para">NODE.JS EXAMPLE</p>

                                        <svg
                                            style={{ cursor: "pointer" }}
                                            onClick={(e) => copyClipboard(e, nodeExample)}
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9 18C8.45 18 7.97933 17.8043 7.588 17.413C7.196 17.021 7 16.55 7 16V4C7 3.45 7.196 2.979 7.588 2.587C7.97933 2.19567 8.45 2 9 2H18C18.55 2 19.021 2.19567 19.413 2.587C19.8043 2.979 20 3.45 20 4V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H9ZM5 22C4.45 22 3.979 21.8043 3.587 21.413C3.19567 21.021 3 20.55 3 20V7C3 6.71667 3.096 6.479 3.288 6.287C3.47933 6.09567 3.71667 6 4 6C4.28333 6 4.521 6.09567 4.713 6.287C4.90433 6.479 5 6.71667 5 7V20H15C15.2833 20 15.521 20.096 15.713 20.288C15.9043 20.4793 16 20.7167 16 21C16 21.2833 15.9043 21.5207 15.713 21.712C15.521 21.904 15.2833 22 15 22H5Z"
                                                fill="#7281B8"
                                            />
                                        </svg>
                                    </div>

                                    <div class="copybox-bottom">
                                        <pre>
                                            <code class="copybox-code">
                                                {nodeExample}
                                            </code>
                                        </pre>
                                    </div>
                                </div>

                                <div class="copybox mb-3">
                            <div class="copybox-top">
                                <p class="copybox-para">cURL.JS EXAMPLE</p>

                                <svg
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => copyClipboard(e, curlExample)}
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M9 18C8.45 18 7.97933 17.8043 7.588 17.413C7.196 17.021 7 16.55 7 16V4C7 3.45 7.196 2.979 7.588 2.587C7.97933 2.19567 8.45 2 9 2H18C18.55 2 19.021 2.19567 19.413 2.587C19.8043 2.979 20 3.45 20 4V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H9ZM5 22C4.45 22 3.979 21.8043 3.587 21.413C3.19567 21.021 3 20.55 3 20V7C3 6.71667 3.096 6.479 3.288 6.287C3.47933 6.09567 3.71667 6 4 6C4.28333 6 4.521 6.09567 4.713 6.287C4.90433 6.479 5 6.71667 5 7V20H15C15.2833 20 15.521 20.096 15.713 20.288C15.9043 20.4793 16 20.7167 16 21C16 21.2833 15.9043 21.5207 15.713 21.712C15.521 21.904 15.2833 22 15 22H5Z"
                                        fill="#7281B8"
                                    />
                                </svg>
                            </div>

                            <div class="copybox-bottom">
                                <pre>
                                    <code class="copybox-code">
                                        {curlExample}
                                    </code>
                                </pre>
                            </div>
                        </div>
                            </section>
                        </article>
                        

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Authentication Best Practices
                                </h2>

                                <table class="table table-bordered table-white">
                                    <thead>
                                        <tr>
                                            <th>Step</th>
                                            <th>Recommendation</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>Generate a unique nonce for every request.</td>
                                        </tr>

                                        <tr>
                                            <td>2</td>
                                            <td>Generate a new HMAC signature for every request.</td>
                                        </tr>

                                        <tr>
                                            <td>3</td>
                                            <td>Store the Secret Key securely on the server side.</td>
                                        </tr>

                                        <tr>
                                            <td>4</td>
                                            <td>Never expose the Secret Key in frontend or mobile applications.</td>
                                        </tr>

                                        <tr>
                                            <td>5</td>
                                            <td>Always send API requests over HTTPS.</td>
                                        </tr>

                                        <tr>
                                            <td>6</td>
                                            <td>Do not share the Access Key or Secret Key publicly.</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </section>
                        </article>

                        <article class="docs-article" id="section-3">
                            <section class="docs-section row" id="item-3-1">
                                <div class="col-12">
                                    <nav aria-label="Page navigation example">
                                        <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                to="/merchant-introduction"
                                                tabIndex="-1"
                                                aria-disabled="true"
                                            >
                                                <i class="bi bi-arrow-left"></i>&nbsp;
                                                Introduction
                                            </Link>
                                        </li>

                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                 to="/merchant-integration-notes"
                                            >
                                                Integration Notes&nbsp;
                                                <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                        </ul>
                                    </nav>
                                </div>

                            </section>

                        </article>

                    </div>
                </div>
                <ToastContainer closeOnClick autoClose={2000}></ToastContainer>
            </div >
        )
    }

}